const getters = {
  getGroupUsers: (state) => state.groupUsers || [],
  getAllUsers: (state) => state.allUsers || [],
  getAnswerRateAnalyticData: (state) => state.answerRateAnalyticData || [],
  getAnswerTotalRateAnalyticData: (state) => state.answerTotalRateAnalyticData || [],
  
  // Belirli bir grubun kullanıcılarını getir
  getUsersByGroupName: (state) => (groupName) => {
    const group = state.groupUsers?.find(g => g.groupName === groupName);
    return group ? group.groupUsers : [];
  },
  
  // Grup isimlerini getir
  getGroupNames: (state) => {
    return state.groupUsers?.map(group => group.groupName) || [];
  },

  // Widget-specific data getters
  getWidgetData: (state) => (widgetId) => {
    return state.widgetData[widgetId] || {};
  },

  // Legacy getters that now use widget-specific data
  getMtDailyOperationalEfficiencyAnalyticData: (state) => (widgetId) => {
    if (widgetId) {
      return state.widgetData[widgetId] || {};
    }
    return state.dailyOperationalEfficiencyData || {};
  },

  getMtOperationalEfficiencyAnalyticData: (state) => (widgetId) => {
    if (widgetId) {
      return state.widgetData[widgetId] || {};
    }
    return state.operationalEfficiencyData || {};
  },

  getMtAnswerRateAnalyticData: (state) => (widgetId) => {
    if (widgetId) {
      return state.widgetData[widgetId] || {};
    }
    return state.answerRateAnalyticData || [];
  },

  getMtTouchingRateAnalyticData: (state) => (widgetId) => {
    if (widgetId) {
      return state.widgetData[widgetId] || {};
    }
    return state.touchingRateAnalyticData || {};
  }
}

export default getters;
